import Vue from 'vue'
import Vuex from 'vuex'

/*
  code 성 message 관리 Vuex
    - getName 함수 필수 구현
    - createInstance 함수 필수 구현
*/

const getName = () => {
  return 'msg'
}

const createInstance = () => {
  let localStore = ''

  if (window.vue.getStore(getName) === undefined) {
    const store = new Vuex.Store({
      state: {
        msgMap: new Map() // key: 메시지 코드, value: json 타입 메시지
      },
      getters: {
        getState: state => {
          return state.msgMap
        }
      },
      mutations: {
        // Message 관리
        CLEAN (state) {
          state.msgMap.clear()
        },
        PUSH (state, msg) {
          var msgMap = state.msgMap
          msgMap.set(msg.name, msg.msg)
        }
      },
      actions: {
        CLEAN ({commit}) {
          return commit('CLEAN')
        },
        PUSH ({commit}, msg) {
          return commit('PUSH', msg)
        }
      }
    })

    localStore = new Vue({
      store: store
    })
  }

  return localStore
}

var store = {}
store.getName = getName
store.createInstance = createInstance

export default store



// WEBPACK FOOTER //
// ./src/_fdp/core/vuex/system/msg.js